import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import { formatFechaWithHour } from "../../../utils/dateFunctions";
import EstadoBadge from "./EstadoBadge";

const OrgTable = () => {
  const { myOrgs } = useSingleUserControl();

  const estadoMap: Record<string, "success" | "warning" | "wrong" | "unknown"> =
    {
      Activo: "success",
      Inactivo: "warning",
      Eliminado: "wrong",
    };

  return (
    <TableContainer
      sx={{
        fontFamily: "Montserrat, sans-serif",
        boxShadow: "none",
        color: "#005559",
        px: 2,
      }}
    >
      <Table
        sx={{
          borderCollapse: "collapse",
          "& .MuiTableCell-root": {
            fontFamily: "Montserrat, sans-serif",
            padding: "6px 12px",
            borderBottom: "none",
            color: "#005559",
          },
        }}
      >
        <TableHead>
          <TableRow
            sx={{
              borderBottom: "1px solid #336B8780", // más gruesa para el header
            }}
          >
            <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Organización</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Fecha de asignación</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Estado</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {myOrgs.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={5}
                align="center"
                sx={{
                  fontStyle: "italic",
                  color: "#7A7A7A",
                  py: 2,
                }}
              >
                No se encuentra asociado a ninguna organización
              </TableCell>
            </TableRow>
          ) : (
            myOrgs.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": { backgroundColor: "#f5f5f5" },
                  borderBottom:
                    index === myOrgs.length - 1 ? "none" : "1px solid #e0e0e0",
                }}
              >
                <TableCell>{row.id_organizacion}</TableCell>
                <TableCell>{row.organizacion}</TableCell>
                <TableCell>{formatFechaWithHour(row.created_at)}</TableCell>
                <TableCell>
                  <EstadoBadge estado={estadoMap[row.estado_org]}>
                    {row.estado_org}
                  </EstadoBadge>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrgTable;
